<template>
  <section class="section section-gray">
    <div class="container text-center fade-in-section">
      <h2 class="section-title">Built by Industry Veterans</h2>
      <p class="section-subtitle max-w-3xl">Our team brings decades of experience of delivering QA to leading companies.</p>
      
      <div class="founders-logos max-w-4xl">
        <div class="logo-item">
          <img src="../assets/images/logos/ericsson.png" alt="Ericsson" class="company-logo">
        </div>
        <div class="logo-item">
          <img src="../assets/images/logos/volvo.png" alt="Volvo" class="company-logo">
        </div>
        <div class="logo-item">
          <img src="../assets/images/logos/scania.png" alt="Scania" class="company-logo">
        </div>
        <div class="logo-item">
          <img src="../assets/images/logos/twitch.png" alt="Twitch" class="company-logo">
        </div>
        <div class="logo-item">
          <img src="../assets/images/logos/tomtom.png" alt="Tomtom" class="company-logo">
        </div>
        <!--
        <div class="logo-item">
          <img src="../assets/images/logos/uncommongoods.png" alt="Uncommongoods" class="company-logo">
        </div>
        <div class="logo-item">
          <img src="../assets/images/logos/zf-group.png" alt="ZF Group" class="company-logo">
        </div>
        -->
        <div class="logo-item">
          <img src="../assets/images/logos/bridgestone.png" alt="Bridgestone" class="company-logo">
        </div>
        <!--
        <div class="logo-item">
          <img src="../assets/images/logos/dassault.png" alt="Dassault" class="company-logo">
        </div>
        -->
        <div class="logo-item">
          <img src="../assets/images/logos/cisco.png" alt="Cisco" class="company-logo">
        </div>
        <div class="logo-item">
          <img src="../assets/images/logos/ford.png" alt="Ford" class="company-logo">
        </div>
        <div class="logo-item">
          <img src="../assets/images/logos/nokia.png" alt="Nokia" class="company-logo">
        </div>
        <div class="logo-item">
          <img src="../assets/images/logos/apple.png" alt="Apple" class="company-logo">
        </div>
      </div>
      
      <div class="founders-stats max-w-3xl">
        <div class="stat-item">
          <span class="stat-number">50+</span>
          <span class="stat-label">Years Combined Experience</span>
        </div>
        <div class="stat-divider"></div>
        <div class="stat-item">
          <span class="stat-number">10K+</span>
          <span class="stat-label">QA Professionals Mentored</span>
        </div>
        <div class="stat-divider"></div>
        <div class="stat-item">
          <span class="stat-number">500+</span>
          <span class="stat-label">Projects Delivered</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TrustSection'
}
</script>
